import { RsValue } from '../../../models/base/BaseModel';
import {
  IHospitalRecordParam,
  IHospitalRecordResult,
} from '../../../models/hospital/HospitalModel';
import { IQrParam, IQrResult } from '../../../models/hospital/QrModel';
import api from '../../axios';

export const hospitalRecordService = {
  listHospitalRecords: (odata: any): Promise<IHospitalRecordResult[]> =>
    api.get('odata/HospitalRecord', odata),
  createHospitalRecord: (data: IHospitalRecordParam): Promise<RsValue<IHospitalRecordResult>> =>
    api.post('HospitalRecord', data),
  readFromQrCode: (qrCodeUrl: IQrParam): Promise<RsValue<IQrResult>> =>
    api.post('HospitalRecord/read-from-qr', qrCodeUrl),
  searchByKnNo: (params: IQrParam): Promise<RsValue<IQrResult>> =>
    api.post('HospitalRecord/search-by-kn', params),
  delete: (id: number): Promise<RsValue<boolean>> => api.delete(`HospitalRecord/${id}`),
  update: (
    id: number,
    data: Partial<IHospitalRecordParam>
  ): Promise<RsValue<IHospitalRecordResult>> => api.put(`HospitalRecord/${id}`, data),
};
